<template>
  <div class="color-project-small" :class="{'disabled-color': disabled}">
    <Dropdown :dataset="currentValue" @change="valueChange" @visible-change="visibleChange">
      <template slot-scope="data">
        <span class="el-dropdown-link">
          <img :src="data.selectColor.backGroundMini" alt="">
          <span class="first-text">{{getFirstText(data)}}</span>
        </span>
      </template>
    </Dropdown>
  </div>
</template>
<script>
import Dropdown from './dropdown'
export default {
  props: {
    dataset: {
      type: Object,
      default: () => {}
    },
    defaultText: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Dropdown
  },
  computed: {
    currentValue: {
      get() {
        if(this.dataset) {
          let arr = JSON.parse(JSON.stringify(this.dataset))
          arr.background_text = this.getText()
          return arr
        } else {
          return {}
        }
      }
    }
  },
  data() {
    return {
      show: false
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getText() {
      if(this?.dataset?.background_text) {
        return this?.dataset?.background_text
      } else if(this.defaultText) {
        return this.defaultText.slice(0, 8)
      } else {
        return ''
      }
    },
    valueChange(item) {
      this.$emit('change', {...this.dataset, ...item})
    },
    visibleChange(val) {
      this.show = val
      this.$emit('visibleChange', val)
    },
    getFirstText(data) {
      return data?.selectColor?.background_text?.slice(0, 1)
    }
  }
}
</script>
<style lang="scss">
.color-project-small {
  .el-dropdown-link {
    display: flex;
    align-items: center;
    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .first-text {
      font-size: 18px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.8);
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &.disabled-color {
    pointer-events: none;
  }
}
</style>
